import React from "react";
import { Input, Select } from "antd";
import TreeSelect from "@/components/TreeSelect";
import { ModelSelectHelper } from "../../../../../services/Sierra/library";

class IBISRender extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      modelInputName: ""
    }
  }

  onModelTypeChange = (key) => {
    const { modelList, modelSelector, modelType: prevType } = this.props;
    if (prevType !== key) {
      const selectedModelList = ModelSelectHelper.filterModelNameList({ modelList, modelType: key, modelSelector })
      this.props.setData({
        modelType: key,
        modelName: "",
        enableVoltage: "",
        selectedModelList
      })
    }
  }

  onSelectModelSelector = (key) => {
    const { modelList, modelType, modelSelector: prevType } = this.props;
    if (prevType !== key) {
      const selectedModelList = ModelSelectHelper.filterModelNameList({ modelList, modelType, modelSelector: key });
      this.props.setData({
        modelSelector: key,
        modelName: "",
        selectedModelList
      })
    }
  }

  modelNameChange = (e) => {
    const modelName = e.target.value;
    this.setState({ modelInputName: modelName });
    if (!modelName) return;
    const { modelList, modelType, modelSelector, } = this.props;
    const model = modelList.find(item => item.name === modelName);
    if (modelName && model) {
      this.setModelName(model);
    } else {
      const modelNameList = ModelSelectHelper.filterModelNameList({ modelList, modelType, modelSelector, modelNameStr: modelName });
      this.props.setData({ modelNameList })
    }
  }

  clickModelName = (modelItem) => {
    const { modelList } = this.props;
    const model = modelList.find(item => item.name === modelItem.name);
    if (model) {
      this.setModelName(model);
    }
  }

  setModelName = (model) => {
    const { modelList } = this.props;
    const { type, selector, enable, deviceVcc } = model;
    const modelNameList = ModelSelectHelper.filterModelNameList({ modelList, modelType: type, modelSelector: selector });

    this.props.setData({
      modelName: model.name,
      modelType: type,
      modelSelector: selector,
      modelNameList,
      enableVoltage: ModelSelectHelper.existEnableVoltage(type) ? (enable === 'NA' ? '1' : enable) : "",
      deviceVcc: deviceVcc || ""
    })
  }

  render() {
    const {
      fileName,
      libraryId,
      modelName,
      modelType,
      modelSelector,
      ibisList,
      modelNameList,
      modelTypeList,
      modelSelectorList
    } = this.props;
    const { modelInputName } = this.state;
    return <>
      <div className="div-flex-box">
        <label>Model File</label>
        <TreeSelect
          className="input-component"
          size='small'
          showSearch
          value={fileName || undefined}
          onSelectItem={this.props.onFolderFileChange}
          fileList={ibisList}
          selected={libraryId}
        />
      </div>
      <div className="div-flex-box div-flex-box-child-box">
        <div className="div-flex-box-child">
          <label>Model Type</label>
          <Select
            className="input-component"
            size="small"
            value={modelType || ""}
            options={modelTypeList}
            onChange={this.onModelTypeChange}
          />
        </div>
        <div className="div-flex-box-child">
          <label>Model Selector</label>
          <Select
            className="input-component"
            size="small"
            value={modelSelector || ""}
            options={modelSelectorList}
            onChange={this.onSelectModelSelector}
          />
        </div>
      </div>
      <div className="div-flex-box">
        <label>Model Name</label>
        <Input
          className="input-component"
          size="small"
          value={modelInputName || modelName}
          onChange={this.modelNameChange}
        />
      </div>
      <div className="model-name-list">
        {modelNameList && modelNameList.map(item => {
          const checked = item.name === modelName
          return <span
            className={checked ? "selected" : ""}
            key={item.name}
            title={item.info}
            onClick={() => this.clickModelName(item)} >
            <span>{item.name}</span>{item.description ? `,\xa0\xa0\xa0\xa0${item.description}` : ""}
          </span>
        })}
      </div>
    </>
  }
}

export default IBISRender;